var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileIconPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8332 17.833V16.1663C15.8332 15.2823 15.482 14.4344 14.8569 13.8093C14.2317 13.1842 13.3839 12.833 12.4998 12.833H7.49984C6.61578 12.833 5.76794 13.1842 5.14281 13.8093C4.51769 14.4344 4.1665 15.2823 4.1665 16.1663V17.833",
    stroke: "#8B38FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 9.49967C11.8408 9.49967 13.3332 8.00729 13.3332 6.16634C13.3332 4.32539 11.8408 2.83301 9.99984 2.83301C8.15889 2.83301 6.6665 4.32539 6.6665 6.16634C6.6665 8.00729 8.15889 9.49967 9.99984 9.49967Z",
    stroke: "#8B38FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIconPurple);
export default __webpack_public_path__ + "static/media/file-icon-purple.f635eac6a2182f1571319c7637a24820.svg";
export { ForwardRef as ReactComponent };